import { Injectable } from '@angular/core';
import { Helpers } from '../utilities/helpers';
import { environment } from '../../../environments/environment';

@Injectable()

export class SharedPreferencesService {

  showHeader: boolean = true;
  showMapCategoryToggle: boolean = false;
  currentMapToogleState = 'map';

  categories: any[] = [
    { id: 1, name: 'Street Food', icon: 'streetfood.svg', slug:'street-food', search_param:[["tags:street-food"]] },
    { id: 2, name: 'Budget Shopping', icon: 'shopping.svg', slug: 'budget', search_param:[["tags:budget", "tags:shopping"]] },
    { id: 3, name: 'Hidden Gems', icon: 'gems.svg', slug: 'hidden-gems', search_param:[["tags:hidden-gems"]] },
    { id: 4, name: 'Romantic Places', icon: 'cupid.svg', slug: 'romantic-places', search_param:[["tags:romantic"]] },
    { id: 5, name: 'Outdoor Cafe', icon: 'cafe.svg', slug: 'outdoor', search_param:[["tags:outdoor", "tags:cafe"]] },
    { id: 6, name: 'Bakeries', icon: 'cake.svg', slug: 'bakeries', search_param:[["tags:desserts-and-bakeries"]] },
    { id: 7, name: 'Libraries', icon: 'library.svg', slug: 'libraries', search_param:[["tags:books-and-stationery"]] },
    { id: 8, name: 'Furniture', icon: 'furniture.svg', slug: 'furniture', search_param:[["tags:furniture"]] },
    { id: 9, name: 'Pets', icon: 'pets.svg', slug: 'pets', search_param:[["tags:for-pets"]] },
    { id: 10, name: 'New in Town', icon: 'startup.svg', slug: 'new-in-town', search_param:[["tags:new-in-town"]] },
    { id: 11, name: 'Kids', icon: 'kids.svg', slug: 'kids', search_param:[["tags:for-kids"]] }
  ];

  locations: any[] = [
    { id: 1, name: 'Delhi NCR', slug: 'delhi', lat: 28.6289332, long: 77.2065322, radius: 136263 },
    { id: 2, name: 'Bengaluru', slug: 'bengaluru', lat: 12.972442, long: 77.580643, radius: 15033 },
    { id: 3, name: 'Mumbai', slug: 'mumbai', lat: 19.228825, long: 72.854118, radius: 13850 }
  ];

  constructor() {}

  getCategory(key, value) {
    for(let category of this.categories) {
      if (category[key] == value) {
        return category;
      }
    }
    return null;
  }

  getLocation(key, value){
    for (let location of this.locations) {
      if (location[key] == value) {
        return location;
      }
    }
    return null;
  }

}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/services/shared-preferences.service.ts